// extracted by mini-css-extract-plugin
export default {"PrivacyPolicyPage":"PrivacyPolicy_PrivacyPolicyPage__iUJtK"};